import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideZoneChangeDetection } from '@angular/core';
import { GusoHeaderSalarieConnecteComponent, provideGusoLibraryConfiguration } from 'guso-libangular';
import { gusoLibConfig } from "../config/environment";

const selector = 'guso-header-salarie-connecte';

// flag pour éviter de booter plusieurs fois
let __gusoConnectedBootstrapped = false;

export async function initGusoHeaderSalarieConnecte(): Promise<void> {
    if (__gusoConnectedBootstrapped) return;
    const el = document.querySelector(selector);
    if (!el) return;
    try {
        await bootstrapApplication(GusoHeaderSalarieConnecteComponent, {
            providers: [provideZoneChangeDetection(), provideGusoLibraryConfiguration(gusoLibConfig)]
        });
        __gusoConnectedBootstrapped = true;
        console.debug('Guso header salarie connecte bootstrappé.');
    } catch (err) {
        console.error('Erreur bootstrap Angular:', err);
    }
}

// expose pour appel depuis JSP / jQuery
(window as any).initGusoHeaderSalarieConnecte = initGusoHeaderSalarieConnecte;
